import React from 'react';

import { Text, TitleMobile } from '@alfalab/core-components/typography';

import styles from './index.module.css';

type TypographyVariant = 'desktop' | 'mobile';

type Props = {
    title: string;
    description: string;
    imgSrc: string;
    index: number;
    typographyVariant?: TypographyVariant;
};

const TYPOGRAPHY_VIEW = {
    desktop: {
        title: { view: 'xsmall' as const },
        description: { view: 'primary-medium' as const },
    },
    mobile: {
        title: { view: 'small' as const },
        description: { view: 'primary-small' as const },
    },
} as const;

export const Step = ({
    title,
    description,
    imgSrc,
    index,
    typographyVariant = 'mobile',
}: Props) => {
    const { title: titleView, description: descriptionView } = TYPOGRAPHY_VIEW[typographyVariant];

    return (
        <div className={styles.container} role='listitem'>
            <TitleMobile tag='h3' view={titleView.view} className={styles.title}>
                <span className={styles.number} aria-hidden={true}>
                    {index}.
                </span>
                {title}
            </TitleMobile>

            <Text
                tag='p'
                view={descriptionView.view}
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
            />

            <figure className={styles.image} aria-hidden='true'>
                <img src={imgSrc} alt='' loading='eager' />
            </figure>
        </div>
    );
};
